import './ContentAndImageBlockOverView.scss';

import cn from 'classnames';
import React from 'react';
import { Image } from '@sitecore-jss/sitecore-jss-react';

export default function OverViewImageBlock({ fields }) {
  return (
    <div className={'container overview-image-block'}>
      <div className={'headtop'}>
        <div className={'wrapper'} data-aos="fade-up">
          <div className={cn('card', fields?.isReversed?.value && 'card_reversed')}>
            <div>
              <h3 className={'card_title'}>{fields?.title?.value}</h3>
              <p className={'card_text'}>{fields?.desc?.value}</p>
            </div>
          </div>
          <div className={'image'}>
            <Image field={fields?.image} alt="img" />
          </div>
        </div>
      </div>
    </div>
  );
}
